/**
 * Maplytics Cookie Consent - RGPD Compliant
 *
 * Integre avec Google Consent Mode v2
 * Peut etre inclus sur toutes les pages qui n'ont pas leur propre banniere.
 *
 * Usage: <script src="/static/js/cookie-consent.js" defer></script>
 */

(function() {
    'use strict';

    // La Home possede son propre gestionnaire. Une inclusion heritee en double
    // ne doit jamais creer un second moteur ou une seconde banniere.
    if (document.getElementById('consent-banner') || window.MaplyticsConsent) {
        return;
    }

    var activeTrigger = null;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function(){ window.dataLayer.push(arguments); };
    var GTM_ID = 'GTM-T3HS2L3B';
    var GA_MEASUREMENT_ID = 'G-025E3KK5WD';
    var ADSENSE_CLIENT = 'ca-pub-8994524269557661';
    var CONSENT_MAX_AGE_MS = 390 * 24 * 60 * 60 * 1000;

    function normalizeConsentPreferences(prefs) {
        if (
            !prefs
            || typeof prefs !== 'object'
            || prefs.essential !== true
            || typeof prefs.analytics !== 'boolean'
            || typeof prefs.advertising !== 'boolean'
        ) {
            return null;
        }
        return {
            essential: true,
            analytics: prefs.analytics,
            advertising: prefs.advertising
        };
    }

    function consentTargetFromPrefs(prefs) {
        if (!prefs) return 'unknown';
        if (prefs.analytics && prefs.advertising) return 'analytics_advertising';
        if (prefs.analytics) return 'analytics_only';
        if (prefs.advertising) return 'advertising_only';
        return 'essential_only';
    }

    function trackConsentAction(action, target) {
        try {
            if (window.MaplyticsPublicActions && typeof window.MaplyticsPublicActions.track === 'function') {
                window.MaplyticsPublicActions.track(action, {
                    target: target || 'shared-consent',
                    surface: 'shared-consent'
                });
            }
        } catch (error) {
            // Aggregate consent diagnostics must never affect the choice UI.
        }
    }

    window.gtag('consent', 'default', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied',
        functionality_storage: 'granted',
        personalization_storage: 'denied',
        security_storage: 'granted',
        wait_for_update: 500
    });

    function migrateLegacyConsent() {
        try {
            if (localStorage.getItem('consent_preferences')) {
                getConsentPreferences();
                return;
            }
            var legacy = localStorage.getItem('cookie_consent');
            if (!legacy) {
                return;
            }
            var parsed = JSON.parse(legacy);
            var acceptedAll = Boolean(parsed && parsed.level === 'all');
            saveConsentPreferences({
                essential: true,
                analytics: acceptedAll || Boolean(parsed && parsed.analytics === true),
                advertising: acceptedAll || Boolean(parsed && parsed.advertising === true)
            });
            localStorage.removeItem('cookie_consent');
        } catch (e) {
            console.warn('Erreur migration preferences cookies:', e);
        }
    }

    function loadScriptOnce(id, src, attrs) {
        if (document.getElementById(id)) {
            return;
        }
        var script = document.createElement('script');
        script.id = id;
        script.async = true;
        script.src = src;
        Object.keys(attrs || {}).forEach(function(key) {
            script.setAttribute(key, attrs[key]);
        });
        document.head.appendChild(script);
    }

    function safeCurrentPath() {
        return window.location.pathname || '/';
    }

    function isSensitiveAuthPage() {
        return safeCurrentPath() === '/auth/reset-password';
    }

    function safeAttributionSearch(search) {
        if (safeCurrentPath() === '/aide/' || safeCurrentPath().indexOf('/aide/') === 0) {
            return '';
        }
        var raw = String(search || '').trim();
        if (!raw) return '';
        try {
            var params = new URLSearchParams(raw.charAt(0) === '?' ? raw.slice(1) : raw);
            var safe = new URLSearchParams();
            ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function(key) {
                var value = params.get(key);
                if (value) safe.set(key, value.slice(0, 80));
            });
            var serialized = safe.toString();
            return serialized ? '?' + serialized : '';
        } catch (error) {
            return '';
        }
    }

    function safePageLocation() {
        return window.location.origin
            + safeCurrentPath()
            + safeAttributionSearch(window.location.search || '');
    }

    function sendGaPageViewOnce() {
        if (window.__maplyticsGaPageViewSent || !GA_MEASUREMENT_ID) {
            return;
        }
        window.__maplyticsGaPageViewSent = true;
        loadScriptOnce(
            'maplytics-ga4-direct',
            'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(GA_MEASUREMENT_ID)
        );
        window.gtag('js', new Date());
        window.gtag('config', GA_MEASUREMENT_ID, {
            page_title: document.title,
            page_location: safePageLocation(),
            page_path: safeCurrentPath() + safeAttributionSearch(window.location.search || ''),
            cookie_expires: 33696000,
            cookie_update: false
        });
        window.dataLayer.push({ event: 'maplytics_ga4_page_view_sent' });
    }

    function loadOptionalScripts(prefs) {
        prefs = normalizeConsentPreferences(prefs);
        if (!prefs || isSensitiveAuthPage()) {
            return;
        }
        if (prefs.analytics) {
            window.dataLayer.push({ event: 'maplytics_consent_analytics_granted' });
            loadScriptOnce(
                'maplytics-gtm',
                'https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(GTM_ID)
            );
            sendGaPageViewOnce();
        }
        if (prefs.advertising) {
            loadScriptOnce(
                'maplytics-adsense',
                'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=' + encodeURIComponent(ADSENSE_CLIENT),
                { crossorigin: 'anonymous' }
            );
        }
    }

    function clearConsentRecord() {
        localStorage.removeItem('consent_preferences');
        localStorage.removeItem('consent_date');
        localStorage.removeItem('cookie_consent');
    }

    function consentDecisionIsCurrent(rawDate) {
        var acceptedAt = Date.parse(String(rawDate || ''));
        var now = Date.now();
        return Number.isFinite(acceptedAt)
            && acceptedAt <= now
            && now - acceptedAt <= CONSENT_MAX_AGE_MS;
    }

    // Recuperer le consentement sauvegarde et redemander le choix a son expiration.
    function getConsentPreferences() {
        try {
            var saved = localStorage.getItem('consent_preferences');
            if (saved) {
                var normalized = normalizeConsentPreferences(JSON.parse(saved));
                if (normalized && consentDecisionIsCurrent(localStorage.getItem('consent_date'))) {
                    return normalized;
                }
                clearConsentRecord();
            }
        } catch (e) {
            clearConsentRecord();
            console.warn('Erreur lecture preferences cookies:', e);
        }
        return null;
    }

    // Sauvegarder les preferences
    function saveConsentPreferences(prefs) {
        var normalized = normalizeConsentPreferences(prefs);
        if (!normalized) return false;
        try {
            localStorage.setItem('consent_preferences', JSON.stringify(normalized));
            localStorage.setItem('consent_date', new Date().toISOString());
            window.dispatchEvent(new CustomEvent('maplytics:consent-updated', { detail: normalized }));
            updateConsentStatus(normalized);
            return true;
        } catch (e) {
            console.warn('Erreur sauvegarde preferences cookies:', e);
            return false;
        }
    }

    // Mettre a jour Google Consent Mode v2
    function updateConsentMode(prefs) {
        prefs = normalizeConsentPreferences(prefs) || {
            essential: true,
            analytics: false,
            advertising: false
        };
        var consentParams = {
            'security_storage': 'granted',
            'ad_storage': prefs.advertising ? 'granted' : 'denied',
            'ad_user_data': prefs.advertising ? 'granted' : 'denied',
            'ad_personalization': prefs.advertising ? 'granted' : 'denied',
            'analytics_storage': prefs.analytics ? 'granted' : 'denied',
            'functionality_storage': 'granted',
            'personalization_storage': prefs.analytics ? 'granted' : 'denied'
        };

        window.gtag('consent', 'update', consentParams);
        loadOptionalScripts(prefs);
    }

    function updateConsentStatus(prefs) {
        var normalized = normalizeConsentPreferences(prefs);
        document.querySelectorAll('[data-cookie-consent-status]').forEach(function(status) {
            status.hidden = !normalized;
            if (!normalized) return;
            var analytics = status.querySelector('[data-consent-status-analytics]');
            var advertising = status.querySelector('[data-consent-status-advertising]');
            if (analytics) analytics.textContent = normalized.analytics ? 'Activés' : 'Désactivés';
            if (advertising) advertising.textContent = normalized.advertising ? 'Activés' : 'Désactivés';
        });
    }

    function ensureManageControl() {
        if (document.querySelector('[data-cookie-consent-open]')) return;
        var control = document.createElement('button');
        control.type = 'button';
        control.className = 'cookie-consent-manage-control';
        control.setAttribute('data-cookie-consent-open', '');
        control.setAttribute('aria-label', 'Gérer les préférences de cookies');
        control.textContent = 'Gérer les cookies';
        control.style.cssText = '\
            position: fixed;\
            left: 12px;\
            bottom: 12px;\
            max-width: calc(100vw - 24px);\
            padding: 8px 12px;\
            border: 1px solid #64748b;\
            border-radius: 999px;\
            background: #ffffff;\
            color: #334155;\
            font: 600 12px/1.2 Inter, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif;\
            box-shadow: 0 2px 10px rgba(15, 23, 42, 0.18);\
            cursor: pointer;\
            z-index: 9998;\
        ';
        document.body.appendChild(control);
    }

    function restoreTriggerFocus() {
        if (activeTrigger && document.contains(activeTrigger) && typeof activeTrigger.focus === 'function') {
            activeTrigger.focus();
        }
        activeTrigger = null;
    }

    // Creer et injecter la banniere partagee. Son ouverture automatique ne
    // vole pas le focus ; une ouverture volontaire place le focus dans le dialogue.
    function createBanner(options) {
        options = options || {};
        var existing = document.getElementById('cookie-consent-banner');
        if (existing) {
            existing.style.transform = 'translateY(0)';
            existing.removeAttribute('aria-hidden');
            if (options.trigger) activeTrigger = options.trigger;
            if (options.focus) {
                var existingReject = existing.querySelector('#cc-reject');
                if (existingReject) existingReject.focus();
            }
            return existing;
        }

        if (options.trigger) activeTrigger = options.trigger;
        var banner = document.createElement('div');
        banner.id = 'cookie-consent-banner';
        banner.setAttribute('role', 'dialog');
        banner.setAttribute('aria-labelledby', 'cookie-consent-title');
        banner.setAttribute('aria-describedby', 'cookie-consent-description');
        banner.setAttribute('data-cookie-consent-dialog', 'true');
        banner.innerHTML = '\
            <div style="max-width: 1200px; margin: 0 auto; display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 20px;">\
                <div style="flex: 1 1 300px; min-width: 0;">\
                    <p id="cookie-consent-title" style="margin: 0 0 8px 0; font-size: 15px; font-weight: 600;">\
                        🍪 Ce site utilise des cookies\
                    </p>\
                    <p id="cookie-consent-description" style="margin: 0; font-size: 13px; color: #cbd5e1; line-height: 1.5;">\
                        Nous utilisons des cookies essentiels, et uniquement avec votre accord des cookies analytics ou publicitaires.\
                        <a href="/privacy" style="color: #a5b4fc; text-decoration: underline;">Politique de confidentialité</a>\
                    </p>\
                </div>\
                <div style="display: flex; gap: 12px; flex-wrap: wrap;">\
                    <button id="cc-reject" type="button" style="\
                        padding: 10px 20px;\
                        background: transparent;\
                        color: white;\
                        border: 1px solid #475569;\
                        border-radius: 6px;\
                        font-size: 14px;\
                        font-weight: 500;\
                        cursor: pointer;\
                    ">Essentiels uniquement</button>\
                    <button id="cc-accept" type="button" style="\
                        padding: 10px 20px;\
                        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\
                        color: white;\
                        border: none;\
                        border-radius: 6px;\
                        font-size: 14px;\
                        font-weight: 600;\
                        cursor: pointer;\
                    ">Accepter tout</button>\
                </div>\
            </div>\
        ';

        // Styles de la banniere
        banner.style.cssText = '\
            position: fixed;\
            bottom: 0;\
            left: 0;\
            right: 0;\
            background: rgba(15, 23, 42, 0.98);\
            color: white;\
            padding: 20px;\
            box-sizing: border-box;\
            max-height: 100vh;\
            overflow-y: auto;\
            z-index: 10000;\
            box-shadow: 0 -4px 20px rgba(0,0,0,0.3);\
            transform: translateY(100%);\
            transition: transform 0.3s ease;\
        ';

        document.body.appendChild(banner);
        if (!getConsentPreferences()) {
            trackConsentAction('consent_banner_viewed', 'banner');
        }

        // Afficher avec animation
        setTimeout(function() {
            banner.style.transform = 'translateY(0)';
            if (options.focus) {
                var reject = banner.querySelector('#cc-reject');
                if (reject) reject.focus();
            }
        }, 100);

        // Event listeners
        banner.querySelector('#cc-accept').addEventListener('click', acceptAllCookies);

        banner.querySelector('#cc-reject').addEventListener('click', rejectOptionalCookies);

        banner.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && getConsentPreferences()) {
                event.preventDefault();
                hideBanner(banner, true);
            }
        });

        return banner;
    }

    function hideBanner(banner, shouldRestoreFocus) {
        banner.style.transform = 'translateY(100%)';
        banner.setAttribute('aria-hidden', 'true');
        setTimeout(function() {
            banner.remove();
            if (shouldRestoreFocus) restoreTriggerFocus();
        }, 300);
    }

    function openCookieConsentPreferences(trigger) {
        return createBanner({ focus: true, trigger: trigger || null });
    }

    function applyConsentChoice(prefs) {
        var previous = getConsentPreferences();
        if (!saveConsentPreferences(prefs)) return;
        trackConsentAction(
            prefs.analytics && prefs.advertising ? 'consent_accepted' : 'consent_rejected',
            consentTargetFromPrefs(prefs)
        );
        updateConsentMode(prefs);
        var banner = document.getElementById('cookie-consent-banner');
        if (banner) hideBanner(banner, true);
        if (
            previous
            && (
                (previous.analytics && !prefs.analytics)
                || (previous.advertising && !prefs.advertising)
            )
        ) {
            setTimeout(function() { window.location.reload(); }, 320);
        }
    }

    function acceptAllCookies() {
        applyConsentChoice({ essential: true, analytics: true, advertising: true });
    }

    function rejectOptionalCookies() {
        applyConsentChoice({ essential: true, analytics: false, advertising: false });
    }

    document.addEventListener('click', function(event) {
        var trigger = event.target.closest('[data-cookie-consent-open], [data-consent-action="open"]');
        if (trigger) {
            event.preventDefault();
            openCookieConsentPreferences(trigger);
            return;
        }
        var accept = event.target.closest('[data-cookie-consent-accept]');
        if (accept) {
            event.preventDefault();
            acceptAllCookies();
            return;
        }
        var reject = event.target.closest('[data-cookie-consent-reject]');
        if (reject) {
            event.preventDefault();
            rejectOptionalCookies();
        }
    });

    // Initialisation
    document.addEventListener('DOMContentLoaded', function() {
        migrateLegacyConsent();
        ensureManageControl();
        var saved = getConsentPreferences();
        updateConsentStatus(saved);
        if (!saved) {
            // Pas de consentement, afficher la banniere apres un delai
            setTimeout(function() { createBanner({ focus: false }); }, 1000);
        } else {
            // Restaurer le consentement precedent
            updateConsentMode(saved);
        }
    });

    // Fonction globale pour revoquer le consentement (accessible depuis /privacy)
    window.revokeCookieConsent = function() {
        localStorage.removeItem('consent_preferences');
        localStorage.removeItem('consent_date');
        localStorage.removeItem('cookie_consent');
        window.dispatchEvent(new CustomEvent('maplytics:consent-updated', {
            detail: { essential: true, analytics: false, advertising: false }
        }));
        trackConsentAction('consent_rejected', 'withdrawal');
        location.reload();
    };

    window.openCookieConsentPreferences = openCookieConsentPreferences;

    window.MaplyticsConsent = {
        getPreferences: getConsentPreferences,
        savePreferences: saveConsentPreferences,
        updateConsentMode: updateConsentMode,
        loadOptionalScripts: loadOptionalScripts,
        acceptAll: acceptAllCookies,
        rejectOptional: rejectOptionalCookies,
        revoke: window.revokeCookieConsent,
        open: openCookieConsentPreferences
    };

})();
